import Vue from 'vue'

import VueCompositionAPI from '@vue/composition-api'
import Translations from '@/components/mixins/Translations'

import '@/assets/js/modules/components/'

Vue.use(VueCompositionAPI)
Vue.mixin(Translations)
